module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userName) ? _c('div', {
    attrs: {
      "id": "GitLab-Provider"
    }
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listBy),
      expression: "listBy"
    }],
    attrs: {
      "type": "radio",
      "id": "inputListByMe",
      "value": "me"
    },
    domProps: {
      "checked": _vm._q(_vm.listBy, "me")
    },
    on: {
      "change": [function($event) {
        _vm.listBy = "me"
      }, _vm.clearAndListByMe]
    }
  }), _c('label', {
    attrs: {
      "for": "inputListByMe"
    }
  }, [_vm._v("Created by me")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listBy),
      expression: "listBy"
    }],
    attrs: {
      "type": "radio",
      "id": "inputListByProject",
      "value": "project"
    },
    domProps: {
      "checked": _vm._q(_vm.listBy, "project")
    },
    on: {
      "change": [function($event) {
        _vm.listBy = "project"
      }, _vm.listByProject]
    }
  }), _c('label', {
    attrs: {
      "for": "inputListByProject"
    }
  }, [_vm._v("By project")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listBy),
      expression: "listBy"
    }],
    attrs: {
      "type": "radio",
      "id": "inputListByGroup",
      "value": "group"
    },
    domProps: {
      "checked": _vm._q(_vm.listBy, "group")
    },
    on: {
      "change": [function($event) {
        _vm.listBy = "group"
      }, _vm.listByGroup]
    }
  }), _c('label', {
    attrs: {
      "for": "inputListByGroup"
    }
  }, [_vm._v("By group/project")]), _vm._v(" "), (!_vm.downloading) ? _c('span', {
    staticClass: "refresh",
    on: {
      "click": _vm.refreshIssues
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Refresh")]) : _vm._e()]), _vm._v(" "), (this.listBy === 'project') ? _c('div', {
    staticClass: "subfilter"
  }, [_c('div', {
    staticClass: "multiselect-container"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.GitLab.projects,
      "value": _vm.project,
      "close-on-select": true,
      "show-labels": false,
      "loading": _vm.downloading,
      "placeholder": "Type to search a project",
      "label": "path_with_namespace"
    },
    on: {
      "search-change": _vm.searchProjects,
      "input": _vm.listProjectIssues
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (this.listBy === 'group') ? _c('div', {
    staticClass: "subfilter"
  }, [_c('div', {
    staticClass: "multiselect-container"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.GitLab.groups,
      "value": _vm.group,
      "close-on-select": true,
      "show-labels": false,
      "loading": _vm.downloading,
      "placeholder": "Type to search a group",
      "label": "path"
    },
    on: {
      "search-change": _vm.searchGroups,
      "input": _vm.selectedGroup
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No group found with this name")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "group-separator"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "multiselect-container"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.GitLab.groupProjects,
      "value": _vm.gProject,
      "close-on-select": true,
      "show-labels": false,
      "loading": _vm.downloading,
      "placeholder": "Search a project (defaults to all)",
      "label": "path_with_namespace"
    },
    on: {
      "search-change": _vm.searchGroupProjects,
      "input": _vm.selectedGroupProject
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No project on this group with this name")])])], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(this.malformed.length) ? _c('div', {
    staticClass: "standardpadding"
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        Some of your GitLab issues comes with malformed GanttStart or GanttDue dates:\n        "), _c('ul', _vm._l((this.malformed), function(issue) {
    return _c('li', [_c('a', {
      attrs: {
        "href": issue.web_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(issue.title))])])
  }), 0), _vm._v("\n        Please use "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates",
      "target": "_blank"
    }
  }, [_vm._v("ISO 8601 calendar dates")]), _vm._v(" to plan your issues start and due dates: "), _c('em', [_vm._v("GanttStart: YYYY-MM-DD")]), _vm._v(" and/or "), _c('em', [_vm._v("GanttDue: YYYY-MM-DD")]), _vm._v(".\n      ")])]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-282d18f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/providers/GitLab.vue
// module id = 156
// module chunks = 2